import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "vercel"
    }}>{`Vercel`}</h1>
    <blockquote>
      <p parentName="blockquote"><inlineCode parentName="p">{`[your-frontend-project]`}</inlineCode>{` = `}<inlineCode parentName="p">{`admin`}</inlineCode>{` `}{`[`}<inlineCode parentName="p">{`rest/graphql`}</inlineCode>{`]`}{` or `}<inlineCode parentName="p">{`shop`}</inlineCode></p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Before procedure vercel, you've to host API on a server, and after that, follow this procedure.`}</p>
    </blockquote>
    <h3 {...{
      "id": "vercelcom"
    }}><a parentName="h3" {...{
        "href": "https://vercel.com/"
      }}>{`vercel.com`}</a></h3>
    <p>{`If you want to host the template in vercel.com then follow the below command`}</p>
    <h3 {...{
      "id": "frontend"
    }}>{`Frontend`}</h3>
    <h4 {...{
      "id": "step-1"
    }}>{`Step 1:`}</h4>
    <ul>
      <li parentName="ul">{`After deploying the api you will get the api endpoint url. Put that url in the `}<inlineCode parentName="li">{`[your-frontend-project]/.env`}</inlineCode>{` and `}<inlineCode parentName="li">{`vercel.json`}</inlineCode>{` file.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-.env"
      }}>{`NEXT_PUBLIC_GRAPHQL_API_ENDPOINT= '{put_your_api_url_here}'
`}</code></pre>
    <p>{`or for `}<inlineCode parentName="p">{`rest`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-.env"
      }}>{`NEXT_PUBLIC_REST_API_ENDPOINT= '{put_your_api_url_here}'
`}</code></pre>
    <h4 {...{
      "id": "step-2"
    }}>{`Step 2:`}</h4>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`and change `}<inlineCode parentName="p">{`FRAMEWORK_PROVIDER`}</inlineCode>{` to `}<inlineCode parentName="p">{`rest`}</inlineCode>{` for REST installation or `}<inlineCode parentName="p">{`graphql`}</inlineCode>{` for Graphql Installation.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Navigate to `}<inlineCode parentName="p">{`[your-frontend-project]`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Open `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` and change `}<inlineCode parentName="p">{`build:rest`}</inlineCode>{` to `}<inlineCode parentName="p">{`build`}</inlineCode>{` for `}<inlineCode parentName="p">{`REST`}</inlineCode>{` or `}<inlineCode parentName="p">{`build:gql`}</inlineCode>{` to `}<inlineCode parentName="p">{`build`}</inlineCode>{` for `}<inlineCode parentName="p">{`GraphQL`}</inlineCode></p>
      </li>
    </ul>
    <h4 {...{
      "id": "step-4"
    }}>{`Step 4:`}</h4>
    <ul>
      <li parentName="ul">{`Navigate to `}<inlineCode parentName="li">{`shop`}</inlineCode></li>
      <li parentName="ul">{`For `}<inlineCode parentName="li">{`REST`}</inlineCode>{`, copy `}<inlineCode parentName="li">{`tsconfig.rest.json`}</inlineCode>{` content to `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode>{`
or`}</li>
      <li parentName="ul">{`For `}<inlineCode parentName="li">{`GraphQL`}</inlineCode>{` copy `}<inlineCode parentName="li">{`tsconfig.graphql.json`}</inlineCode>{` content to `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode></li>
      <li parentName="ul">{`Now run below command`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`vercel
`}</code></pre>
    <p><img alt="shop deploy" src={require("../../images/shop-deploy.jpg")} /></p>
    <p><strong parentName="p">{` NOTE: `}</strong>{` for deploying to `}<inlineCode parentName="p">{`vercel`}</inlineCode>{` you need to install `}<inlineCode parentName="p">{`vercel-cli`}</inlineCode>{` on your machine for more information please visit `}<a parentName="p" {...{
        "href": "https://vercel.com/docs/cli?query=cli#introduction/vercel-cli-reference"
      }}>{`here`}</a></p>
    <h3 {...{
      "id": "for-others-hosting-providers"
    }}>{`For others hosting providers:`}</h3>
    <p>{`Please follow `}<a parentName="p" {...{
        "href": "https://nextjs.org/docs/deployment"
      }}>{`nextjs deployment docs: `}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      